import { IApplicationState } from '../../types/redux';

export function getIsFlatTourBookingAvailable(state: IApplicationState) {
  const { flatTourBooking } = state;

  return Boolean(flatTourBooking);
}
